import React from 'react';
import BixButton from '../bixButton';
import './index.scss';

interface IDataSitesNoteProps {
  onCloseModal: () => void;
}

const DataSitesLegend: React.FC<IDataSitesNoteProps> = props => {
  return (
    <>
      <div className="data-sites-notes-text">
        <ul>
          <li>Available on Bixby</li>
          <ul>
            <li>Currently available on your Bixby portfolio</li>
          </ul>
          <li>Eligible</li>
          <ul>
            <li>Eligible for coverage, click "Prioritize" if you'd like to have this company moved up in your queue</li>
          </ul>
          <li>No USD Loans</li>
          <ul>
            <li>European structure, only available with European coverage add-on</li>
          </ul>
          <li>Public</li>
          <ul>
            <li>Publicly traded, not eligible for Bixby coverage (Bixby covers private loan issuers)</li>
          </ul>
          <li>Syndication</li>
          <ul>
            <li>Syndication data site, not eligible for Bixby coverage (Bixby covers Agency and Secondary sites)</li>
          </ul>
          <li>Data Site Missing Information</li>
          <ul>
            <li>
              Data site currently has insufficient information to create a model, please reach out to the agent to have
              information added; if you'd like to track this as a "news only" site until information becomes available
              please contact us
            </li>
          </ul>
          <li>Other - Contact Bixby</li>
          <ul>
            <li>
              In process of reviewing data site to confirm eligibility, for additional information please contact us
            </li>
          </ul>
        </ul>
      </div>
      <BixButton onClick={props.onCloseModal}>Close</BixButton>
    </>
  );
};

export default DataSitesLegend;
